// extracted by css-extract-rspack-plugin
export default {"annotationsHeaderFileName":"AlertsSidePanel-module__annotationsHeaderFileName__SvspuZQ"};